// import React, { useEffect, useState } from 'react';
// import Layout from '../layout/Layout';
// import PageTransition from '../components/PageTransition';
// import { getusers as getAllUsers } from '../components/DbServices'; // Create this service

// export default function AdminUserReports() {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const res = await getAllUsers();
//       if (res.status === 200) {
//         setUsers(res.data);
//       }
//     } catch (err) {
//       console.error("Error fetching reports:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Filter based on search input
//   const filteredData = users.filter(item => 
//     item.name.toLowerCase().includes(search.toLowerCase()) || 
//     item.email.toLowerCase().includes(search.toLowerCase()) ||
//     item.mobile.includes(search)
//   );

//   return (
//     <Layout>
//       <PageTransition>
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <h3 className="fw-bold">Users Report</h3>
//           <div className="d-flex gap-2">
//             <input 
//               type="text" 
//               className="form-control form-control-sm border-0 shadow-sm" 
//               placeholder="Search users..." 
//               style={{ width: '250px' }}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//             <button className="btn btn-primary btn-sm rounded-3 shadow-sm px-3" onClick={() => window.print()}>
//               <i className="fas fa-print me-2"></i> Print Report
//             </button>
//           </div>
//         </div>

//         {/* METRICS SUMMARY */}
//         <div className="row mb-4">
//           <MetricCard title="Total Registered" value={users.length} icon="fa-users" color="primary" />
//           <MetricCard title="Active Accounts" value={users.filter(u => u.status === '1').length} icon="fa-user-check" color="success" />
//           <MetricCard title="Admin Roles" value={users.filter(u => u.role === 'admin').length} icon="fa-user-shield" color="info" />
//         </div>

//         <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
//           <div className="table-responsive">
//             <table className="table table-hover align-middle mb-0">
//               <thead className="bg-light text-muted small text-uppercase">
//                 <tr>
//                   <th className="ps-4">ID</th>
//                   <th>User Details</th>
//                   <th>Role</th>
//                   <th>Joined Date</th>
//                   <th>Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ? (
//                   <tr><td colSpan="7" className="text-center py-5">Loading records...</td></tr>
//                 ) : filteredData.length > 0 ? (
//                   filteredData.map((user) => (
//                     <tr key={user.id}>
//                       <td className="ps-4 text-muted">#{user.id}</td>
//                       <td>
//                         <div className="fw-bold mb-0">{user.name}</div>
//                         <div className="text-muted small">{user.email}</div>
//                       </td>
//                       <td>
//                         <span className={`badge ${user.role === 'admin' ? 'bg-danger-subtle text-danger' : 'bg-secondary-subtle text-secondary'} rounded-pill`}>
//                           {user.role}
//                         </span>
//                       </td>
//                       <td className="small">{new Date(user.created_at).toLocaleDateString()}</td>
//                       <td>
//                         <span className={`dot ${user.status === '1' ? 'bg-success' : 'bg-warning'} me-2`}></span>
//                         {user.status === '1' ? 'Active' : 'Pending'}
//                       </td>
                     
//                     </tr>
//                   ))
//                 ) : (
//                   <tr><td colSpan="7" className="text-center py-5">No users found matching your search.</td></tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </PageTransition>
//     </Layout>
//   );
// }

// function MetricCard({ title, value, icon, color }) {
//   return (
//     <div className="col-md-4">
//       <div className="card border-0 shadow-sm rounded-4 p-3">
//         <div className="d-flex align-items-center">
//           <div className={`bg-${color}-subtle text-${color} p-3 rounded-circle me-3`}>
//             <i className={`fas ${icon} fa-lg`}></i>
//           </div>
//           <div>
//             <div className="text-muted small fw-bold text-uppercase">{title}</div>
//             <h4 className="fw-bold mb-0">{value}</h4>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useState } from 'react';
import Layout from '../layout/Layout';
import PageTransition from '../components/PageTransition';
// Ensure updateUserRole is exported from your DbServices
import { getusers as getAllUsers,editUser as updateUserRole } from '../components/DbServices';
import Swal from 'sweetalert2';

export default function AdminUserReports() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {

      const res = await getAllUsers();
      debugger
      if (res.status === 200) setUsers(res.data || []);
    } catch (err) {
      console.error("Error fetching reports:", err);
    } finally {
      setLoading(false);
    }
  };

  // ROLE CHANGE LOGIC
  const handleRoleToggle = async (user, newRole) => {
    if (user.role === newRole) return;
    if (!window.confirm(`Change ${user.name}'s permission to ${newRole.toUpperCase()}?`)) return;

    try {
      const res = await updateUserRole(user.id, { role: newRole });
      if (res.status === 200) {
        // Optimistic Update: Refresh the local state immediately
        setUsers(users.map(u => u.id === user.id ? { ...u, role: newRole } : u));
      }
    } catch (err) {
      Swal.fire("Failed to update role. Please check connection.");
    }
  };

  const filteredData = users.filter(item => 
    item.name?.toLowerCase().includes(search.toLowerCase()) || 
    item.email?.toLowerCase().includes(search.toLowerCase()) ||
    item.mobile?.includes(search)
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  return (
    <Layout>
      <PageTransition>
        <div className="container-fluid py-4">
          
          {/* ACTION BAR */}
          <div className="row align-items-center mb-4 g-3">
            <div className="col-md-6">
      
              <h3 className="fw-bold mb-1"><span className="color-theme">User Management</span></h3>
              <p className="text-muted small fw-medium mb-0">Review, update, and manage system access levels.</p>
            </div>
            
            <div className="col-md-6">
              <div className="d-flex gap-2 justify-content-md-end">
                <div className="input-group shadow-sm rounded-pill overflow-hidden border bg-white px-3" style={{ maxWidth: '300px' }}>
                  <span className="bg-transparent border-0 text-muted py-2"><i className="bi bi-filter-left fs-5"></i></span>
                  <input 
                    type="text" 
                    className="form-control border-0 bg-transparent shadow-none small" 
                    placeholder="Search name or email..." 
                    value={search}
                    onChange={handleSearch}
                  />
                </div>
                <button className="btn btn-primary rounded-pill px-3 fw-bold border-2 small" onClick={() => window.print()}>
                  <i className="bi bi-cloud-arrow-down me-2"></i> Export
                </button>
              </div>
            </div>
          </div>

          {/* KPI SECTION */}
          <div className="row g-3 mb-4">
            <MetricCard title="Total Users" value={users.length} icon="bi-people" color="indigo" trend="+12% this month" />
            <MetricCard title="Verified" value={users.filter(u => u.status === '1').length} icon="bi-patch-check" color="success" trend="Active now" />
            <MetricCard title="Administrators" value={users.filter(u => u.role === 'admin').length} icon="bi-shield-shaded" color="danger" trend="High privilege" />
          </div>

          {/* DATA TABLE */}
          <div className="card border-0 shadow-sm rounded-4 overflow-hidden bg-white">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="border-bottom" style={{ backgroundColor: '#fcfdfe' }}>
                  <tr className="text-muted small text-uppercase fw-bold">
                    <th className="ps-4 py-4 border-0">User Identity</th>
                    <th className="py-4 border-0 text-center">Permissions</th>
                    <th className="py-4 border-0">Contact Info</th>
                    <th className="py-4 border-0 text-end">Onboarding</th>
                    <th className="pe-4 py-4 border-0 text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="5" className="text-center py-5">
                      <div className="spinner-grow text-primary spinner-grow-sm me-2"></div>
                      <span className="text-muted small fw-bold">Syncing Database...</span>
                    </td></tr>
                  ) : currentItems.length > 0 ? (
                    currentItems.map((user) => (
                      <tr key={user.id} className="border-bottom border-light">
                        <td className="ps-4 py-3">
                          <div className="d-flex align-items-center gap-3">
                            <div className={`avatar-square rounded-3 fw-bold d-flex align-items-center justify-content-center ${user.role === 'admin' ? 'bg-danger-subtle text-danger' : 'bg-primary-subtle text-primary'}`} style={{ width: '40px', height: '40px' }}>
                              {user.name?.substring(0, 2).toUpperCase()}
                            </div>
                            <div>
                              <div className="fw-bold text-dark small mb-0">{user.name}</div>
                              <div className="text-muted x-small lh-1">{user.email}</div>
                            </div>
                          </div>
                        </td>
                        <td className="text-center">
                          {/* UPDATED: DROPDOWN FOR ROLE CHANGE */}
                          <div className="dropdown">
                            <button 
                                className={`btn btn-sm dropdown-toggle rounded-pill fw-bold px-3 ${user.role === 'admin' ? 'bg-danger text-white' : 'bg-light text-dark'}`} 
                                type="button" 
                                data-bs-toggle="dropdown"
                                style={{ fontSize: '9px', letterSpacing: '0.5px' }}
                            >
                                <i className={`bi ${user.role === 'admin' ? 'bi-star-fill' : 'bi-person'} me-1`}></i>
                                {user.role?.toUpperCase()}
                            </button>
                            <ul className="dropdown-menu shadow-sm border-0 small">
                                <li><button className="dropdown-item py-2" onClick={() => handleRoleToggle(user, 'user')}><i className="bi bi-person me-2"></i> Set as User</button></li>
                                <li><button className="dropdown-item py-2" onClick={() => handleRoleToggle(user, 'admin')}><i className="bi bi-shield-lock me-2 text-danger"></i> Set as Admin</button></li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <div className="small fw-medium text-dark">{user.mobile || '—'}</div>
                          <div className="x-small text-muted">Direct Mobile</div>
                        </td>
                        <td className="text-end">
                          <div className="small text-dark fw-bold">{new Date(user.created_at).toLocaleDateString()}</div>
                          <div className="x-small text-muted">via Web Signup</div>
                        </td>
                        <td className="pe-4 text-end">
                          <div className="dropdown">
                            <button className="btn btn-light btn-sm rounded-circle border-0" data-bs-toggle="dropdown">
                              <i className="bi bi-three-dots-vertical"></i>
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end shadow-sm border-0 rounded-3 small">
                              <li><button className="dropdown-item py-2"><i className="bi bi-pencil me-2 text-primary"></i> Edit User</button></li>
                              <li><button className="dropdown-item py-2 text-danger"><i className="bi bi-trash me-2"></i> Suspend</button></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center py-5">
                        <i className="bi bi-folder2-open display-4 text-light d-block mb-3"></i>
                        <span className="text-muted fw-medium">No results found for "{search}"</span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* PAGINATION */}
          {!loading && totalPages > 1 && (
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 gap-3">
              <div className="text-muted small fw-medium">
                Page <span className="text-dark fw-bold">{currentPage}</span> of {totalPages}
              </div>
              <nav>
                <ul className="pagination pagination-sm mb-0 gap-1 border-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link rounded-3 border-0 bg-light text-dark shadow-sm px-3" onClick={() => setCurrentPage(prev => prev - 1)}>Previous</button>
                  </li>
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link rounded-3 border-0 bg-light text-dark shadow-sm px-3" onClick={() => setCurrentPage(prev => prev + 1)}>Next</button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </PageTransition>
    </Layout>
  );
}

function MetricCard({ title, value, icon, color, trend }) {
  return (
    <div className="col-md-4">
      <div className="card border-0 shadow-sm rounded-4 p-3 bg-white">
        <div className="d-flex justify-content-between align-items-start">
          <div className="d-flex align-items-center">
            <div className={`rounded-3 bg-${color}-subtle text-${color} p-3 me-3`}>
              <i className={`bi ${icon} fs-4`}></i>
            </div>
            <div>
              <div className="text-muted small fw-bold text-uppercase lh-1 mb-1" style={{ letterSpacing: '0.5px' }}>{title}</div>
              <h3 className="fw-black mb-0">{value}</h3>
            </div>
          </div>
        </div>
        <div className="mt-3 pt-3 border-top x-small text-muted fw-medium">
           <i className="bi bi-arrow-up-right text-success me-1"></i> {trend}
        </div>
      </div>
    </div>
  );
}